import { faClone, faEye, faPen, faPrint } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardMenu } from "../menus/StandardMenu"
import { StandardMenuItem } from "../menus/StandardMenuItem"

export type RecurrenceSeriesOrderActions = Readonly<{
    onEditOrder: (orderId: number) => void
    onCopyOrder: (orderId: number) => void
    getPrintAction: (orderId: number) => (() => void) | undefined
}>

type Props = Readonly<{
    anchorEl: HTMLElement | null
    orderId: number
    isLocked: boolean
    actions: RecurrenceSeriesOrderActions
    onViewOrder: (orderId: number) => void
    onClose: () => void
}>

export function RecurrenceSeriesOrderMenu({ anchorEl, orderId, isLocked, actions, onViewOrder, onClose }: Props) {
    const print = actions.getPrintAction(orderId)

    const runAndClose = (action: () => void) => () => {
        onClose()
        action()
    }

    return (
        <StandardMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <StandardMenuItem icon={faEye} onClick={runAndClose(() => onViewOrder(orderId))}>
                <LocalizedStrict id="meeting-service-recurrence-series-drawer-order-menu-view">
                    <span>View order</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <StandardMenuItem
                icon={faPen}
                disabled={isLocked}
                onClick={runAndClose(() => actions.onEditOrder(orderId))}
            >
                <LocalizedStrict id="meeting-service-recurrence-series-drawer-order-menu-edit">
                    <span>Edit order</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <StandardMenuItem icon={faClone} onClick={runAndClose(() => actions.onCopyOrder(orderId))}>
                <LocalizedStrict id="meeting-service-recurrence-series-drawer-order-menu-copy">
                    <span>Copy order</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <StandardMenuItem icon={faPrint} disabled={!print} onClick={print && runAndClose(print)}>
                <LocalizedStrict id="meeting-service-recurrence-series-drawer-order-menu-print">
                    <span>Print order</span>
                </LocalizedStrict>
            </StandardMenuItem>
        </StandardMenu>
    )
}
